// Lista de template-uri de newsletter
export const newsletterTemplates = [

  {
    id: "newsletter-prdp-martie-2026",
    name: "Newsletter PRDP – Martie 2026",
    subject: "Luna începuturilor. Luna în care se vede cine suntem.",
    getContent: (data) => `
  <!doctype html>
  <html lang="ro">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <title>Newsletter PRDP – Martie</title>
    <style>
      @media only screen and (max-width:600px){
        .container{width:100% !important;}
        .padded{padding:16px !important;}
      }
      body { line-height: 1.6 !important; font-family: Arial, Helvetica, sans-serif; }
      p { margin: 12px 0 !important; color: #333; }
      h3 { margin-top: 24px; margin-bottom: 12px; font-size: 18px; color: #01358d; text-transform: uppercase; }
      ul { margin: 0 0 16px 0; padding-left: 20px; }
      li { margin-bottom: 4px; color: #333; }
      .text-red { color: #d32f2f !important; }
      .divider { border: 0; border-top: 1px solid #e0e0e0; margin: 24px 0; }
      .highlight { font-weight: bold; color: #d32f2f; }
    </style>
  </head>
  
  <body style="margin:0;padding:0;background-color:#f4f7f9;font-family:Arial,Helvetica,sans-serif;color:#222;">
  <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="padding:24px 12px;">
  <tr><td align="center">
  
  <table width="680" class="container" cellpadding="0" cellspacing="0" role="presentation"
  style="max-width:680px;background:#fff;border-radius:8px;overflow:hidden;">
  
  <tr>
  <td style="background:linear-gradient(90deg,#01358d,#0f73c9);padding:32px;color:#fff;">
    <h1 style="margin:0;font-size:24px;font-weight:700;">NEWSLETTER PRDP – MARTIE</h1>
    <p style="margin:8px 0 0;font-size:16px;color:#fff;opacity:0.9;">
      Luna începuturilor. Luna în care se vede cine suntem.
    </p>
  </td>
  </tr>
  
  <tr>
  <td class="padded" style="padding:32px;">
  
  <h3>🌸 1 MARTIE – ÎNCEPUTURI CARE CONTEAZĂ</h3>
  <p>Dragi colegi,</p>
  <p>Martie nu e doar o lună din calendar.<br>
  E acel moment din an în care simți că lucrurile pot porni din nou. Mai limpede. Mai hotărât. Mai curat.</p>
  <p>La mulți ani de Mărțișor tuturor celor care cred în construcții serioase, nu în improvizații.</p>
  
  <hr class="divider">
  
  <h3>🌷 8 MARTIE – DESPRE FORȚA CARE ȚINE LUMEA ÎN ECHILIBRU</h3>
  <p>La mulți ani femeilor din PRDP și din România.<br>
  Mamă. Soție. Colegă. Prietenă. Lider.</p>
  <p>O organizație fără femei puternice nu are echilibru.<br>
  O națiune care nu respectă femeia nu are viitor.</p>
  <p>Astăzi spunem simplu: mulțumim. Pentru forță. Pentru răbdare. Pentru demnitate.</p>
  
  <hr class="divider">
  
  <h3>🚀 PRDP CREȘTE. SERIOS. ORGANIZAT. OFICIAL.</h3>
  <p>Nu suntem un experiment.<br>
  Nu suntem o reacție de moment.<br>
  Suntem un proiect construit etapă cu etapă.</p>
  
  <ul>
    <li>Deschidem noi filiale.</li>
    <li>Stabilim coordonatori oficiali.</li>
    <li>Consolidăm structuri locale.</li>
    <li>Pregătim lansări oficiale în teritoriu.</li>
  </ul>
  
  <p>Aceasta este o etapă de construcție reală.<br>
  Se muncește. Se organizează. Se investește.</p>
  
  <p>Cine este aici acum, este la începutul unei construcții care va conta peste ani.</p>
  
  <hr class="divider">
  
  <h3>👕 MATERIAL IDENTITAR OFICIAL PRDP</h3>
  <p>Am definitivat design-ul ținutei oficiale PRDP.</p>
  <p>Este material identitar oficial.<br>
  Este disciplină vizuală.<br>
  Este coerență.<br>
  Este recunoaștere în comunitate.</p>
  
  <hr class="divider">
  
  <h3>🇪🇺 DELEGAȚIA OFICIALĂ PRDP – BRUXELLES</h3>
  <p>Urmează stabilirea datei pentru vizita oficială la Parlamentul European.</p>
  <p>Va exista o delegație oficială PRDP.</p>
  <p>Cei care doresc să facă parte din delegația oficială sunt invitați să trimită un email la:</p>
  <p style="font-weight:bold;color:#01358d;">contact@prdp.ro</p>
  <p>Subiect: „Pentru delegația oficială Bruxelles”</p>
  
  <hr class="divider">
  
  <h3 class="text-red">🎯 „VREI SĂ FII PARLAMENTAR?”</h3>
  <p>Deschidem oficial procesul de selecție pentru viitori candidați PRDP:</p>
  <ul>
    <li>Parlamentul României</li>
    <li>Parlamentul European</li>
    <li>Nivel local</li>
  </ul>
  <p>Trimite CV-ul tău la:</p>
  <p style="font-weight:bold;color:#01358d;">contact@prdp.ro</p>
  <p>Subiect: „Candidatură Parlamentară”</p>
  
  <hr class="divider">
  
  <h3>🏛 POZIȚII ÎN PARTID – IMPLICARE REALĂ</h3>
  <p>Căutăm pentru structura PRDP:</p>
  <ul>
    <li>avocați</li>
    <li>contabili</li>
    <li>videografi</li>
    <li>fotografi</li>
    <li>graphic designeri</li>
    <li>web designeri</li>
    <li>specialiști IT</li>
    <li>responsabil oficial PR și relații cu presa</li>
  </ul>
  <p>Scrie la <span style="font-weight:bold;color:#01358d;">contact@prdp.ro</span> și spune clar în ce domeniu vrei să contribui.</p>
  
  <hr class="divider">
  
  <h3 class="text-red">⚖ DESPRE RESPONSABILITATEA FINANCIARĂ</h3>
  <p>Cotizația recomandată este <span class="highlight">50 de lei pe lună</span>.</p>
  <p>Există membri care au restanțe.<br>
  Vă rugăm ferm să vă actualizați situația financiară.</p>
  <p>Fiecare contribuție înseamnă organizare, materiale, logistică și dezvoltare reală.</p>
  <p>În situațiile în care restanțele persistă, vom aplica prevederile statutare.</p>
  
  <hr class="divider">
  
  <h3>🔥 DE CE MERITĂ</h3>
  <p>Drumul nu este ușor.<br>
  Nu este comod.<br>
  Nu este pentru cei care caută scurtături.</p>
  
  <p>Suntem printre puținii care pot spune că participă la construcția unei forțe politice de la zero. Curată. Independentă. Asumată.</p>
  
  <div style="margin: 30px 0; padding: 20px; background: #f1f3f5; border-left: 5px solid #01358d; font-style: italic; color: #1d3557;">
    „Nu construim un partid pentru a ocupa funcții. Construim o forță care să redea oamenilor demnitatea de a conta. Dacă fiecare își face partea, România nu mai este un vis – devine o realitate care se ridică în picioare.”<br><br>
    — Părintele fondator, Alin Mureșanu
  </div>
  
  <p>Istoria nu este scrisă de cei care comentează.<br>
  Este scrisă de cei care construiesc.</p>
  
  <br>
  
  <p style="background:#f0f0f0; padding:15px; border-radius:4px; border-left: 4px solid #01358d;">
    Cu respect,<br>
    <strong>Echipa PRDP</strong>
  </p>
  
  </td>
  </tr>
  
  <tr>
  <td style="background:#01358d;color:#fff;text-align:center;padding:24px;">
  <p style="margin:0;font-weight:700; color: #fff">Partidul România Dreaptă și Prosperă</p>
  <p style="font-size:12px;margin-top:8px; color: #fff; opacity: 0.8;">
  © 2026 PRDP • Newsletter
  </p>
  </td>
  </tr>
  
  </table>
  
  </td></tr>
  </table>
  </body>
  </html>
    `,
  },

  {
    id: "newsletter-prdp-2026",
    name: "Newsletter PRDP – 2026",
    subject: "Anul în care nu mai explicăm. Anul în care construim forța.",
    getContent: (data) => `
  <!doctype html>
  <html lang="ro">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <title>Newsletter PRDP – 2026</title>
    <style>
      @media only screen and (max-width:600px){
        .container{width:100% !important;}
        .padded{padding:16px !important;}
      }
      body { line-height: 1.6 !important; font-family: Arial, Helvetica, sans-serif; }
      p { margin: 12px 0 !important; color: #333; }
      h3 { margin-top: 24px; margin-bottom: 12px; font-size: 18px; color: #01358d; }
      ul { margin: 0 0 16px 0; padding-left: 20px; }
      li { margin-bottom: 4px; color: #333; }
      .text-red { color: #d32f2f !important; }
      .divider { border: 0; border-top: 1px solid #e0e0e0; margin: 24px 0; }
    </style>
  </head>
  
  <body style="margin:0;padding:0;background-color:#f4f7f9;font-family:Arial,Helvetica,sans-serif;color:#222;">
  <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="padding:24px 12px;">
  <tr><td align="center">
  
  <table width="680" class="container" cellpadding="0" cellspacing="0" role="presentation"
  style="max-width:680px;background:#fff;border-radius:8px;overflow:hidden;">
  
  <tr>
  <td style="background:linear-gradient(90deg,#01358d,#0f73c9);padding:24px;color:#fff;">
    <h1 style="margin:0;font-size:22px;font-weight:700;">NEWSLETTER PRDP – 2026</h1>
    <p style="margin:8px 0 0;font-size:14px;color:#fff;">
      Anul în care nu mai explicăm. Anul în care construim forța.
    </p>
  </td>
  </tr>
  
  <tr>
  <td class="padded" style="padding:32px;">
  
  <h3 class="text-red">🔴 O realitate pe care nimeni nu o spune pe față</h3>
  
  <p>Politica românească funcționează de zeci de ani după același tipar: bani mulți, structuri închise, privilegii protejate, rotație de cadre, zero asumare.</p>
  
  <p>Marile partide:</p>
  <ul>
    <li>primesc subvenții anuale uriașe de la stat,</li>
    <li>sunt finanțate de mari firme, ONG-uri, rețele externe,</li>
    <li>trăiesc din inerție și din lipsa alternativelor reale.</li>
  </ul>
  
  <p>PRDP nu are nimic din toate acestea.<br>
  PRDP are oameni.</p>
  
  <p>Oameni care:</p>
  <ul>
    <li>donează din propriul venit,</li>
    <li>renunță la confort,</li>
    <li>investesc timp, nervi și resurse într-un proiect care nu promite funcții, ci responsabilitate.</li>
  </ul>
  
  <p>Fără aceste contribuții, proiectul nu ar exista.<br>
  Cu ele, proiectul crește, se extinde și capătă forță politică reală.</p>
  
  <hr class="divider">
  
  <h3>🟦 2026: anul vizibilității naționale</h3>
  
  <p>2026 nu este anul spectacolelor ieftine.<br>
  Este anul cristalizării.</p>
  <ul>
    <li>Creștem pas cu pas, pentru că doar așa se construiește ceva durabil.</li>
    <li>Extindem structurile locale și județene.</li>
    <li>Ne pregătim terenul pentru 2028 – restartul încrederii publice.</li>
  </ul>
  
  <p>Toate acestea costă.<br>
  Costă timp. Costă energie. Costă bani.</p>
  
  <p>Cine înțelege acest adevăr nu întreabă „de ce se cer donații”, ci întreabă „cât mai pot contribui ca să accelerăm”.</p>
  
  <hr class="divider">
  
  <h3>🟦 Transparență reală, nu decorativă</h3>
  
  <p>Refacem complet site-ul PRDP.</p>
  
  <p>Nu pentru imagine.<br>
  Nu pentru like-uri.<br>
  Ci pentru conectare directă cu cetățeanul.</p>
  
  <p>Un site mai:</p>
  <ul>
    <li>interactiv,</li>
    <li>clar,</li>
    <li>orientat spre soluții,</li>
    <li>ușor de folosit.</li>
  </ul>
  
  <p>Tot ce reprezintă PRDP — doctrină, ideologie, valori — va fi pus acolo la vedere, fără ocolișuri.<br>
  Este un efort financiar și logistic serios, dar absolut necesar pentru faza în care intrăm.</p>
  
  <hr class="divider">
  
  <h3>🟦 Lupta cu abuzurile statului – fără pauză</h3>
  
  <p>În 2025 și continuăm în 2026:</p>
  <ul>
    <li>am atacat abuzuri ale statului,</li>
    <li>am contestat politici la limita Constituției și a legii,</li>
    <li>am denunțat decizii profund imorale, chiar dacă erau „corecte pe hârtie”.</li>
  </ul>
  
  <p>Această luptă nu este gratuită.<br>
  Presupune resurse, expertiză, timp și determinare.</p>
  
  <p>Dacă vrem să continuăm, trebuie să susținem acest efort inclusiv financiar.</p>
  
  <hr class="divider">
  
  <h3>🟦 Comunități, administrație, garanții reale</h3>
  
  <p>Suntem foarte aproape de a începe întâlniri directe în comunități, în țară și în diaspora.</p>
  
  <p>Nu întâlniri de poză.<br>
  Întâlniri de lucru.</p>
  
  <p>Am început să cooptăm oameni din administrația publică locală, inclusiv primari.<br>
  Ultima cooptare: primarul unei comune din județul Constanța, cu peste 1.000 de locuitori.</p>
  
  <p>Asta înseamnă:</p>
  <ul>
    <li>validare,</li>
    <li>încredere,</li>
    <li>capacitate de guvernare locală.</li>
  </ul>
  
  <p>Este genul de pas care se face doar atunci când există structură și susținere reală.</p>
  
  <hr class="divider">
  
  <h3>🟦 Antreprenoriat, muncă, valoare</h3>
  
  <p>PRDP:</p>
  <ul>
    <li>taxe zero pe salariul minim,</li>
    <li>taxe zero pentru familii monoparentale,</li>
    <li>taxe zero la export în primii 3 ani,</li>
    <li>lobby activ și mediere cu autoritățile.</li>
  </ul>
  
  <p>În paralel:</p>
  <ul>
    <li>oferim soluții digitale ONG-urilor și asociațiilor civice,</li>
    <li>sprijinim inițiativele care produc valoare reală.</li>
  </ul>
  
  <p>Toate aceste politici nu sunt slogane.<br>
  Sunt angajamente care trebuie susținute cu resurse.</p>
  
  <hr class="divider">
  
  <h3>🟦 Deschidere internațională</h3>
  
  <p>Așteptăm confirmarea pentru o nouă vizită în Parlamentul European.<br>
  Cei care vor să participe sunt invitați să ne contacteze.</p>
  
  <p>Prezența internațională înseamnă:</p>
  <ul>
    <li>vizibilitate,</li>
    <li>legitimitate,</li>
    <li>influență.</li>
  </ul>
  
  <p>Și, din nou, înseamnă investiție.</p>
  
  <hr class="divider">
  
  <h3>🟦 Finanțarea – motorul creșterii</h3>
  
  <p>PRDP crește exclusiv din:</p>
  <ul>
    <li>donațiile membrilor,</li>
    <li>contribuții voluntare,</li>
    <li>sprijinul celor care cred în proiect.</li>
  </ul>
  
  <p>Fiecare donație:</p>
  <ul>
    <li>grăbește extinderea,</li>
    <li>crește impactul mesajului,</li>
    <li>ajută direct oameni și comunități.</li>
  </ul>
  
  <p>Cine vrea rezultate rapide trebuie să înțeleagă un lucru simplu:<br>
  fără finanțare, nu există forță politică.</p>
  
  <hr class="divider">
  
  <h3>🟦 PRDP Membri – aplicația mobilă</h3>
  
  <p>Lucrăm la lansarea aplicației „PRDP Membri” în App Store și Google Play.</p>
  
  <p>Aceasta va fi:</p>
  <ul>
    <li>canalul principal de comunicare internă,</li>
    <li>instrument de mobilizare,</li>
    <li>platformă de coordonare a acțiunilor și proiectelor.</li>
  </ul>
  
  <p>Nu este un moft tehnologic.<br>
  Este coloana vertebrală a organizării noastre.</p>
  
  <hr class="divider">
  
  <h3 class="text-red">🔴 Implicare sau plecare</h3>
  
  <p>PRDP nu este un club simbolic.</p>
  
  <p>Dacă:</p>
  <ul>
    <li>nu înțelegi misiunea,</li>
    <li>nu te implici,</li>
    <li>nu contribui fizic și financiar,</li>
  </ul>
  
  <p>te rugăm să ne contactezi pentru clarificare sau să soliciți retragerea din partid.</p>
  
  <p>Nu ne permitem membri pasivi.<br>
  România nu ne permite asta.</p>
  
  <hr class="divider">
  
  <h3>🟦 Campania națională „Fii parlamentar PRDP”</h3>
  
  <p>Începem campania „Fii parlamentar PRDP”.</p>
  
  <p>Mesajul este direct:<br>
  fiecare dintre voi poate deveni următorul lider PRDP.</p>
  
  <p>Deputat.<br>
  Senator.<br>
  Europarlamentar.</p>
  
  <p>Nu contează de unde vii.<br>
  Contează:</p>
  <ul>
    <li>ce știi,</li>
    <li>ce poți face,</li>
    <li>cât muncești,</li>
    <li>cât de loial ești proiectului PRDP.</li>
  </ul>
  
  <p>Selecția va fi:</p>
  <ul>
    <li>dură,</li>
    <li>obiectivă,</li>
    <li>bazată pe competență, CV real și implicare demonstrată.</li>
  </ul>
  
  <p>Nu costă nimic să aplici.<br>
  Dar va costa enorm dacă nu ești dispus să muncești și să susții proiectul, inclusiv financiar.</p>
  
  <p>PRDP nu caută vedete.<br>
  Caută constructori.</p>
  
  <hr class="divider">
  
  <h3>🟦 Recrutarea: responsabilitate morală</h3>
  
  <p>PRDP nu crește singur.</p>
  
  <p>Fiecare membru are datoria morală și obiectivă să:</p>
  <ul>
    <li>vorbească cu familia,</li>
    <li>convingă prieteni,</li>
    <li>aducă colaboratori,</li>
    <li>atragă oameni de valoare.</li>
  </ul>
  
  <p>Nimic nu cade din cer.<br>
  Dacă nu ne extindem noi rețeaua, nu o va face nimeni în locul nostru.</p>
  
  <hr class="divider">
  
  <h3 class="text-red">⚠️ Atenție la agitatori și dezinformare</h3>
  
  <p>Există persoane pe rețelele sociale care:</p>
  <ul>
    <li>se pretind membri PRDP,</li>
    <li>creează tensiuni,</li>
    <li>răspândesc scenarii false.</li>
  </ul>
  
  <p>Am exclus 8 membri și 1 membru al Biroului Național pentru prejudicierea imaginii partidului.</p>
  
  <p>Nu contează sumele donate.<br>
  Nu contează funcția.<br>
  Greșești, plătești.</p>
  
  <hr class="divider">
  
  <h3 class="text-red">🟥 Concluzie</h3>
  
  <p>PRDP nu este un proiect comod.<br>
  Este un proiect necesar.</p>
  
  <p>Cine vrea să construiască viitorul României,<br>
  o face acum, cu resursele pe care le are, alături de oameni care trag în aceeași direcție.</p>
  
  <p>Restul vor rămâne spectatori.</p>
  
  <br>
  
  <p style="background:#f0f0f0; padding:15px; border-radius:4px; border-left: 4px solid #01358d;">
    <strong>📩 Contact</strong><br><br>
    📧 <a href="mailto:contact@prdp.ro" style="color:#01358d;text-decoration:none;">contact@prdp.ro</a><br>
    📱 WhatsApp: 0753-339-849
  </p>
  
  </td>
  </tr>
  
  <tr>
  <td style="background:#01358d;color:#fff;text-align:center;padding:18px;">
  <p style="margin:0;font-weight:700; color: #fff">Partidul România Dreaptă și Prosperă</p>
  <p style="font-size:12px;margin-top:8px; color: #fff">
  © 2026 PRDP • Newsletter
  </p>
  </td>
  </tr>
  
  </table>
  
  </td></tr>
  </table>
  </body>
  </html>
    `,
  },
  
  
  {
    id: "scrisoare-presedinte-final-an-2025",
    name: "Scrisoare oficială – Final de an 2025",
    subject: "Scrisoare către membri și susținători – Final de an 2025",
    getContent: (data) => `
  <!doctype html>
  <html lang="ro">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <title>PRDP – Scrisoare final de an 2025</title>
    <style>
      @media only screen and (max-width:600px){
        .container{width:100% !important;}
        .padded{padding:16px !important;}
      }
      body { line-height: 1.7 !important; }
      p { margin: 14px 0 !important; }
    </style>
  </head>
  
  <body style="margin:0;padding:0;background-color:#f4f7f9;font-family:Arial,Helvetica,sans-serif;color:#222;">
  <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="padding:24px 12px;">
  <tr><td align="center">
  
  <table width="680" class="container" cellpadding="0" cellspacing="0" role="presentation"
  style="max-width:680px;background:#fff;border-radius:8px;overflow:hidden;">
  
  <!-- HEADER -->
  <tr>
  <td style="background:linear-gradient(90deg,#01358d,#0f73c9);padding:22px 24px;color:#fff;">
    <h1 style="margin:0;font-size:20px;">Scrisoare către membri și susținători</h1>
    <p style="margin:6px 0 0;font-size:13px;">
      Final de an 2025 – Partidul România Dreaptă și Prosperă
    </p>
  </td>
  </tr>
  
  <!-- CONTENT -->
  <tr>
  <td class="padded" style="padding:28px;">
  
  <p>
  Dragi colegi, membri, susținători și prieteni ai Partidului România Dreaptă și Prosperă,
  </p>
  
  <p>
  Nu a fost un an ușor. Lucrurile se mișcă mai încet decât îmi doream și ne doream, dar se mișcă pentru că le facem să se miște.
  </p>
  
  <p>
  Anul 2025 a fost, pentru mine și pentru Partidul România Dreaptă și Prosperă, un an de construcție grea, asumată și profund responsabilă. Am devenit președinte al PRDP, preluând și continuând munca începută și predată de Biroul Național, cu aceeași seriozitate și cu aceeași direcție clară.
  </p>
  
  <p>
  Am continuat lupta pentru dobândirea totală a personalității juridice a PRDP, într-un cadru birocratic și juridic adesea absurd, care ne-a testat limitele răbdării, dar nu și determinarea. Am făcut pași importanți și, cred eu, originali pentru un partid neparlamentar — un partid care nu a fost părtaș la jaful național din ultimele decenii.
  </p>
  
  <p>
  PRDP nu face parte din actuala clasă politică coruptă, vândută și eșuată. Și, poate pentru prima dată după mult timp, am arătat că un partid neparlamentar poate face politică acolo unde contează, poate fi relevant și poate produce conținut politic real: oameni noi cu ambiții politice sănătoase, soluții concrete și proiecte serioase pentru viitorul României.
  </p>
  
  <p>
  În acest sens, menționez vizita la Parlamentul European, participarea în cadrul Comisiei Europene la două ședințe, participarea la evenimentul de schimbare a Consulului Italiei în România, precum și prezența noastră constantă, pe parcursul anului 2025, la numeroase conferințe, simpozioane și dezbateri, atât naționale, cât și internaționale, fizice și online. Toate acestea au avut un scop clar: networking, deschidere și extinderea paletei de colaboratori.
  </p>
  
  <p>
  Am continuat, pentru prima dată, proiecte care poate păreau imposibil de pus negru pe alb. Vorbim despre răspunderea penală a magistraților, despre un nou plan național care presupune o reorganizare bugetară profundă și stoparea finanțării entităților care reprezintă doar găuri negre în bugetul de stat și în buzunarele contribuabililor. Entități care, din 1990 până astăzi, nu au adus niciun euro la buget și care trebuie oprite, pentru ca resursele să fie redirecționate către proiecte de interes național, strategic și macro: infrastructură, dezvoltare și economie reală.
  </p>
  
  <p>
  În total, am realizat 32 de proiecte cu impact direct asupra economiei, politicii și planului social.
  </p>
  
  <p>
  Au fost zile de frustrare și momente de blocaj, dar au fost și mult mai multe zile care ne-au lăsat profund recunoscători pentru echipa pasionată, profesionistă și extrem de dedicată cu care am norocul să lucrez.
  </p>
  
  <p>
  Anul 2025 a fost o asumare — o asumare colectivă, împreună cu colegii mei din PRDP, a rolului de nouă forță politică într-un context dominat de zgomot, manipulare, atacuri și presiuni constante. Și chiar și așa, sunt mândru de colegii mei care, zi de zi, lucrează pentru oameni. Sunt mândru că nu am făcut niciun detur de la parcursul pe care ni l-am asumat și de la lucrurile în care credem.
  </p>
  
  <p>
  Mulțumesc tuturor celor care au avut și au încredere în noi, celor care s-au înscris în PRDP, celor care participă cu tot ce pot și cu tot ce știu pentru ca lucrurile să se miște în direcția bună. Cele mai mari mulțumiri se îndreaptă către cei care pun umărul, care contribuie concret și care cred.
  </p>
  
  <p>
  Vă aștept pe toți într-un 2026 plin de proiecte noi, cu determinare și chef de muncă. Pentru că avem treabă.
  </p>
  
  <p style="font-weight:700;">
  România are nevoie de noi.
  </p>
  
  <p>
  Cu respect,<br/>
  <strong>Președintele Partidului România Dreaptă și Prosperă</strong>
  </p>
  
  </td>
  </tr>
  
  <!-- FOOTER -->
  <tr>
  <td style="background:#01358d;color:#fff;text-align:center;padding:18px;">
  <p style="margin:0;font-weight:700;">PRDP merge mai departe.</p>
  <p style="font-size:12px;margin-top:8px;">
  © 2025 Partidul România Dreaptă și Prosperă • Scrisoare oficială
  </p>
  </td>
  </tr>
  
  </table>
  
  </td></tr>
  </table>
  </body>
  </html>
    `,
  },
  
  {
    id: "newsletter-craciun-2025",
    name: "Newsletter Special – Crăciun 2025",
    subject: "PRDP – Crăciun 2025: Claritate, rezistență și un nou început",
    getContent: (data) => `
  <!doctype html>
  <html lang="ro">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <title>PRDP – Crăciun 2025</title>
    <style>
      @media only screen and (max-width:600px){
        .container{width:100% !important;}
        .padded{padding:16px !important;}
      }
      body { line-height: 1.6 !important; }
      p { margin: 12px 0 !important; }
      h2 { margin: 20px 0 10px 0 !important; color: #01358d !important; font-size: 16px !important; }
      ul { 
        margin: 8px 0 12px 20px !important; 
        padding: 0 !important; 
      }
      li { 
        margin: 0 0 6px 0 !important; 
        padding-left: 4px !important;
        display: block !important;
      }
      .bullet::before {
        content: "• ";
        color: #01358d;
        font-weight: bold;
        margin-right: 8px;
      }
    </style>
  </head>
  
  <body style="margin:0;padding:0;background-color:#f4f7f9;font-family:Arial,Helvetica,sans-serif;color:#222;">
  <table width="100%" cellpadding="0" cellspacing="0" role="presentation" style="padding:24px 12px;">
  <tr><td align="center">
  
  <table width="680" class="container" cellpadding="0" cellspacing="0" role="presentation"
  style="max-width:680px;background:#fff;border-radius:8px;overflow:hidden;">
  
  <!-- HEADER -->
  <tr>
  <td style="background:linear-gradient(90deg,#01358d,#0f73c9);padding:20px 24px;color:#fff;">
    <table width="100%" role="presentation">
      <tr>
        <td>
          <h1 style="margin:0;font-size:20px;">🟦 NEWSLETTER OFICIAL PRDP</h1>
          <p style="margin:6px 0 0;font-size:13px;">
            Crăciun 2025 – Un nou început pentru România Dreaptă și Prosperă
          </p>
        </td>
        <td align="right">
          <span style="background:#fffaf0;color:#8a5b06;padding:6px 12px;border-radius:18px;font-weight:700;">
            PRDP
          </span>
        </td>
      </tr>
    </table>
  </td></tr>
  
  <!-- MAIN -->
  <tr>
  <td class="padded" style="padding:22px;">
  
  <!-- INTRO -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="background:#eef6ff;padding:16px;border-radius:6px;">
  <p style="margin:0;">
  Dragi membri, susținători și prieteni ai <strong>Partidului România Dreaptă și Prosperă (PRDP)</strong>,
  </p>
  <p style="margin:0;">
  În pragul Sărbătorii Nașterii Domnului, vă transmitem cele mai sincere urări de sănătate, pace, putere și speranță. Crăciunul este despre adevăr, solidaritate și renaștere – valori care definesc PRDP și ne unesc.
  </p>
  </td></tr></table>
  
  <!-- SCHIMBARE CONDUCERE -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="border:1px solid #e6eef7;padding:16px;border-radius:6px;">
  <h2>🔔 Schimbare de conducere</h2>
  <p style="margin:0;">
  În urma unei analize profunde, conducerea PRDP a fost reorganizată, iar funcția de <strong>Președinte al Partidului</strong> a fost preluată direct de <strong>Președintele Fondator, domnul Alin Mureșanu</strong>.
  </p>
  <p style="margin:0;">
  Decizia a fost luată pentru consolidarea partidului, protejarea identității PRDP și asigurarea unei conduceri ferme, coerente și responsabile.
  </p>
  </td></tr></table>
  
  <!-- ATACURI IT -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="border:1px solid #e6eef7;padding:16px;border-radius:6px;">
  <h2>🛡️ Atacuri informatice grave</h2>
  <ul style="margin:8px 0 12px 20px;">
  <li class="bullet">tentative de spargere a hostingului PRDP</li>
  <li class="bullet">compromiterea e-mailurilor și conturilor sociale</li>
  <li class="bullet">folosirea frauduloasă a însemnelor partidului</li>
  <li class="bullet">dezactivarea paginii Facebook</li>
  <li class="bullet">tentative de acces neautorizat la echipamente</li>
  </ul>
  <p style="margin:0;">
  Aceste atacuri arată clar că PRDP deranjează și că mesajul nostru ajunge unde trebuie.
  </p>
  </td></tr></table>
  
  <!-- MASURI -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="border:1px solid #e6eef7;padding:16px;border-radius:6px;">
  <h2>⚙️ Măsuri de urgență</h2>
  <ul style="margin:8px 0 0 20px;">
  <li class="bullet">reinstalarea sistemelor și resetarea conturilor</li>
  <li class="bullet">securizarea platformelor digitale</li>
  <li class="bullet">implementarea de protocoale IT noi</li>
  </ul>
  </td></tr></table>
  
  <!-- APEL -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="background:#fffaf0;padding:16px;border-radius:6px;">
  <h2 style="color:#8a5b06;">⚠️ Apel important către membri</h2>
  <ul style="margin:8px 0 0 20px;">
  <li class="bullet">schimbați imediat parolele</li>
  <li class="bullet">folosiți autentificare în doi pași</li>
  <li class="bullet">nu dați curs mesajelor suspecte</li>
  <li class="bullet">semnalați orice tentativă de fraudă</li>
  </ul>
  </td></tr></table>
  
  <!-- 2026 -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="border:1px solid #e6eef7;padding:16px;border-radius:6px;">
  <h2>🚀 2026 – Anul ieșirii în teren</h2>
  <ul style="margin:8px 0 0 20px;">
  <li class="bullet">acțiuni directe în comunități</li>
  <li class="bullet">organizare teritorială reală</li>
  <li class="bullet">întâlniri cu cetățenii</li>
  <li class="bullet">reconstrucție de jos în sus</li>
  </ul>
  <p style="margin-top:8px;font-weight:700;">Nu promisiuni. FAPTE.</p>
  </td></tr></table>
  
  <!-- MESAJ PRESEDINTE -->
  <table width="100%" role="presentation" style="margin-bottom:16px;">
  <tr><td style="border:1px solid #e6eef7;padding:16px;border-radius:6px;">
  <h2>🟦 Mesajul Președintelui</h2>
  <p style="font-style:italic;border-left:3px solid #d4a12a;padding:10px;background:#fffaf0;border-radius:6px;margin:12px 0;">
  "Un lider adevărat nu se retrage când lucrurile devin grele – se așază în față."
  </p>
  <p style="margin:8px 0 0;">
  Am preluat conducerea PRDP din responsabilitate, nu din orgoliu. Știu ce urmează, știu cum reacționează sistemul și știu cât valorează oamenii care rămân.
  </p>
  <p style="margin:0;">
  PRDP intră într-o etapă de organizare, disciplină și prezență reală în teren. PRDP este aici ca să rămână.
  </p>
  <p style="margin-top:8px;font-weight:700;">
  — Alin Mureșanu, Președinte Fondator PRDP
  </p>
  </td></tr></table>
  
  <!-- INCHEIERE -->
  <table width="100%" role="presentation">
  <tr><td style="text-align:center;padding:16px;">
  <p style="font-weight:700;">
  🎄 Crăciun Fericit, cu lumină în suflet și curaj în inimă!
  </p>
  <p>PRDP merge mai departe. România are nevoie de noi.</p>
  </td></tr>
  </table>
  
  </td></tr>
  
  <!-- FOOTER -->
  <tr>
  <td style="background:#01358d;color:#fff;text-align:center;padding:20px;">
  <p style="margin:0;font-weight:700;">🐝 Împreună suntem PRDP. Împreună ridicăm România.</p>
  <p style="font-size:12px;margin-top:8px;">
  © 2025 PRDP • Mesaj trimis membrilor și susținătorilor
  </p>
  </td></tr>
  
  </table>
  
  </td></tr>
  </table>
  </body>
  </html>
    `,
  },
   
     
  {
  id: "newsletter-oct-nov-2025",
  name: "Newsletter #4 – Octombrie & Noiembrie 2025",
  subject: "PRDP: Toamna faptelor – implicare, transparență, direcție",
  getContent: (data) => `
    <!doctype html>
    <html lang="ro">
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <title>PRDP: Toamna faptelor – implicare, transparență, direcție</title>
      <style>
        /* Minimal responsive helpers (kept small; major styling inline for email clients) */
        @media only screen and (max-width:600px){
          .container{width:100% !important;}
          .stack-column{display:block !important;width:100% !important;max-width:100% !important;}
          .center-on-narrow{text-align:center !important;display:block !important;margin-left:auto !important;margin-right:auto !important;}
          .padded{padding:16px !important;}
        }
      </style>
    </head>
    <body style="margin:0;padding:0;background-color:#f4f7f9;font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;color:#222;">
      <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color:#f4f7f9;padding:24px 12px;">
        <tr>
          <td align="center">
            <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="680" class="container" style="width:100%;max-width:680px;background-color:#ffffff;border-radius:8px;overflow:hidden;border-collapse:separate;">
              <!-- Header -->
              <tr>
                <td style="background:linear-gradient(90deg,#01358d,#0f73c9);padding:20px 24px;color:#ffffff;">
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0">
                    <tr>
                      <td valign="middle" style="vertical-align:middle;">
                        <table role="presentation" cellpadding="0" cellspacing="0" border="0">
                          <tr>
                            <td style="width:64px;height:64px;border-radius:8px;background:linear-gradient(180deg,#d4a12a,#f0c65d);display:inline-block;text-align:center;vertical-align:middle;">
                              <span aria-hidden="true" style="display:inline-block;line-height:64px;font-size:28px;">🐝</span>
                            </td>
                            <td style="padding-left:12px;vertical-align:middle;">
                              <h1 id="title" style="margin:0;font-size:20px;line-height:1.1;color:#ffffff;font-weight:700;">NEWSLETTER OFICIAL PRDP</h1>
                              <p style="margin:4px 0 0;font-size:13px;color:rgba(255,255,255,0.95);">Partidul România Dreaptă și Prosperă — Luna trecută &amp; Obiectivele lunii în curs</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td align="right" style="vertical-align:middle;">
                        <!-- optional small badge -->
                        <span style="display:inline-block;padding:6px 10px;border-radius:18px;background:#fffaf0;color:#8a5b06;font-weight:700;font-size:13px;">PRDP</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <!-- Main content -->
              <tr>
                <td style="padding:22px;background-color:#ffffff;">
                  <!-- Section: Cuvântul Părintelui Fondator -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:14px;border-radius:6px;background:#eef6ff;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">🟦 Cuvântul Părintelui Fondator – Alin Claudiu Mureșanu</h2>
                        <p style="margin:0 0 10px 0;font-style:italic;border-left:3px solid #d4a12a;padding:10px 12px;background:#fffaf0;border-radius:6px;">„Forța noastră nu stă în bugete uriașe sau în nume grele, ci în inima fiecărui om care crede că România merită mai mult. PRDP este dovada că demnitatea, solidaritatea și credința într-un viitor prosper pot renaște din curajul celor simpli, dar neînfricați.”</p>
                        <p style="margin:0 0 8px 0;line-height:1.5;color:#222;">Dragi membri și voluntari,<br>
                        Luna trecută a fost una intensă, cu pași importanți și investiții semnificative în direcția consolidării PRDP. Suntem un partid în creștere, susținut de oameni reali, nu de interese ascunse, iar acest lucru se vede în fiecare acțiune, fiecare drum și fiecare steag ridicat.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Raport financiar -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">💰 RAPORT FINANCIAR &amp; INVESTIȚII STRATEGICE</h2>
                        <p style="margin:0 0 10px 0;color:#666;font-size:13px;">Cheltuielile totale ale PRDP în luna precedentă au fost de <strong>17.898 lei</strong>, ușor dezechilibrate față de veniturile încasate.</p>
                        <ul style="margin:8px 0 12px 20px;padding:0;color:#222;">
                          <li>✅ Achiziționarea <strong>steagurilor PRDP</strong> pentru viitorul protest național;</li>
                          <li>✅ Plata <strong>flyerelor</strong> și a graficii oficiale;</li>
                          <li>✅ Achiziția unui <strong>calculator performant</strong>, în valoare de <strong>8.000 lei</strong>, obținut cu reducere de 48%;</li>
                          <li>✅ Plata onorariilor <strong>avocaților</strong> care ne-au reprezentat în instanță, cu un tarif preferențial de <strong>25% din valoarea normală</strong>;</li>
                          <li>✅ Contractarea unei <strong>agenții de copywriting</strong>, pentru pregătirea textelor și discursurilor din viitoarea campanie (martie 2026).</li>
                        </ul>
                        <p style="margin:0 0 8px 0;line-height:1.5;color:#222;">Pe lângă acestea, s-au acoperit o serie de cheltuieli curente legate de întreținerea și funcționarea sediilor, iar <strong>Președintele Fondator</strong> a susținut personal mai multe donații în acest sens.</p>
                        <p style="margin:0 0 8px 0;line-height:1.5;color:#222;"><strong>Totodată, PRDP va oferi în perioada următoare <strong>un laptop unui student aflat într-o situație financiară dificilă</strong>, cu intenția ca acesta să fie ulterior angajat în cadrul partidului. Gestul simbolizează grija noastră față de tinerii României și sprijinul pentru educație, muncă și speranță.</strong></p>
                        <p style="margin:0 0 8px 0;line-height:1.5;color:#222;">Am sprijinit, în limita posibilităților, mai multe <strong>cazuri umanitare</strong> semnalate pe TikTok și prin e-mail – dovadă că PRDP rămâne aproape de oameni și de realitate.</p>
                        <p style="margin:0;color:#222;line-height:1.5;"><strong>Suntem conștienți că, din punct de vedere financiar, nu o ducem grozav</strong> — dar suntem mândri de asta, pentru că în PRDP nu există nimic dubios, nicio finanțare ascunsă, nicio umbră de interes străin. Nu avem ONG-uri intermediare, nu avem milionari de carton, nu decontăm bani de la stat. Tot ce se face aici se face <strong>din inimă, din muncă și din credință curată.</strong></p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Protestul national -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">🚩 PROTESTUL NAȚIONAL PRDP – PÂNĂ LA SFÂRȘITUL ANULUI</h2>
                        <p style="margin:0 0 10px 0;line-height:1.5;color:#222;">Ne pregătim de o mare acțiune publică: un protest legal și pașnic împotriva <strong>austerității</strong>, <strong>incoerenței politice</strong>, <strong>abuzurilor administrative</strong> și <strong>lipsei de soluții reale</strong> din partea actualei guvernări.</p>
                        <p style="margin:0 0 10px 0;line-height:1.5;color:#222;">Vom protesta și împotriva <strong>femicidului</strong>, fenomen social dureros, dar ignorat, și împotriva <strong>haosului decizional</strong> care afectează familiile, antreprenorii și cetățenii.</p>
                        <p style="margin:0 0 8px 0;font-weight:700;color:#222;">📢 Vă rugăm pe toți cei care doriți să participați să confirmați pe:</p>
                        <ul style="margin:8px 0 12px 20px;color:#222;">
                          <li>Grupurile PRDP (WhatsApp / Telegram)</li>
                          <li>Sau la adresa: <a href="mailto:contact@prdp.ro" style="color:#01358d;text-decoration:underline; font-size:16px">contact@prdp.ro</a></li>
                        </ul>
                        <p style="margin:0 0 8px 0;color:#222;">Trimiteți: <strong>nume, prenume și intenția de participare.</strong> Această acțiune va marca un moment de vizibilitate națională pentru partidul nostru.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Material identitar -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">🧢 MATERIAL IDENTITAR PRDP</h2>
                        <p style="margin:0 0 8px 0;color:#222;">Am început definitivarea designului pentru:</p>
                        <ul style="margin:8px 0 12px 20px;color:#222;">
                          <li>Șepcuțe, veste, hanorace și tricouri de campanie;</li>
                          <li>Steaguri, insigne și brelocuri PRDP.</li>
                        </ul>
                        <p style="margin:0 0 8px 0;color:#222;">Acestea nu sunt simple materiale promoționale, ci <strong>MATERIALE IDENTITARE</strong> — simboluri prin care dorim să fim văzuți, recunoscuți și respectați în comunități.</p>
                        <p style="margin:0;color:#222;">În curând va fi lansată <strong>secțiunea SHOP PRDP</strong>, unde membrii și voluntarii vor putea comanda echipamentele oficiale.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Activitati si dezvoltare -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">🧭 ACTIVITĂȚI ȘI DEZVOLTARE</h2>
                        <ul style="margin:8px 0 12px 20px;color:#222;">
                          <li>Părintele Fondator, <strong>Alin Claudiu Mureșanu</strong>, a parcurs luna trecută peste <strong>8.000 km</strong>, în întâlniri și discuții cu primari din localități mici și mijlocii;</li>
                          <li>Suntem în discuții avansate pentru <strong>filiala Timișoara</strong> și <strong>filiala Brașov</strong>;</li>
                          <li>Se pregătește o <strong>contracampanie pentru Președinția României</strong>, vizând analiza critică a administrației actuale și a modului incoerent de guvernare;</li>
                          <li>Continuăm demersurile pentru <strong>obținerea personalității juridice</strong> a partidului;</li>
                          <li>Am lansat <strong>aplicația PRDP</strong>, unde au fost adăugate cursuri noi de dezvoltare personală și politică;</li>
                          <li>Felicităm toți membrii care au parcurs aceste cursuri și au obținut puncte de implicare!</li>
                        </ul>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Lansarea oficiala -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">🏛️ LANSAREA OFICIALĂ A PRDP – PARLAMENTUL ROMÂNIEI</h2>
                        <p style="margin:0 0 8px 0;color:#222;">În perioada următoare, ne pregătim pentru <strong>lansarea oficială a PRDP în Parlamentul României</strong>, un moment istoric pentru mișcarea noastră.</p>
                        <p style="margin:0 0 8px 0;color:#222;">Bugetul estimat pentru acest eveniment se ridică la <strong>7.500–8.000 euro</strong>, un buget modest, dar încărcat de semnificație și demnitate.</p>
                        <p style="margin:0 0 8px 0;color:#222;">Începând din luna viitoare, vom colabora cu <strong>influenceri, agenții media, podcasturi și emisiuni TV</strong>, pentru a aduce PRDP în atenția publicului larg. Ne dorim să transpunem în viața reală tot ceea ce am construit online — să fim <strong>în mijlocul oamenilor</strong>, să <strong>ascultăm, să învățăm</strong> și <strong>să depășim așteptările</strong> românilor care cred în noi.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Topul implicarii (table) -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 12px 0;color:#01358d;font-size:18px;">🏆 TOPUL IMPLICĂRII PRDP</h2>
                        <table role="table" aria-label="Top implicare" cellpadding="6" cellspacing="0" border="0" width="100%" style="border-collapse:collapse;font-size:14px;">
                          <thead>
                            <tr>
                              <th align="left" style="border-bottom:1px solid #eee;padding-bottom:8px;">Loc</th>
                              <th align="left" style="border-bottom:1px solid #eee;padding-bottom:8px;">Nume</th>
                              <th align="left" style="border-bottom:1px solid #eee;padding-bottom:8px;">Rol</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="padding-top:8px;padding-bottom:8px;">🥇 1</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Alin Claudiu Mureșanu</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Părinte Fondator</td>
                            </tr>
                            <tr>
                              <td style="padding-top:8px;padding-bottom:8px;">🥈 2</td>
                              <td style="padding-top:8px;padding-bottom:8px;">David Ciprian Banu</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Vicepreședinte, coordonator IT și strategie digitală</td>
                            </tr>
                            <tr>
                              <td style="padding-top:8px;padding-bottom:8px;">🥉 3</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Gina Claudia Moldoveanu</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Comunicare și imagine</td>
                            </tr>
                            <tr>
                              <td style="padding-top:8px;padding-bottom:8px;">4️⃣</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Dumitra Ștefania Neagu</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Organizare și relații interne</td>
                            </tr>
                            <tr>
                              <td style="padding-top:8px;padding-bottom:8px;">5️⃣</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Irina Elisabeta Manea</td>
                              <td style="padding-top:8px;padding-bottom:8px;">Logistică și mobilizare teritorială</td>
                            </tr>
                          </tbody>
                        </table>
                        <p style="margin:12px 0 0 0;color:#222;">Mulțumim tuturor pentru implicare, sacrificii și pentru fiecare clipă dedicată mișcării noastre! 💛</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Proiecte & Prioritati -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">💡 PROIECTE &amp; PRIORITĂȚI PENTRU LUNA ÎN CURS</h2>
                        <ul style="margin:8px 0 12px 20px;color:#222;">
                          <li>Finalizarea producției și personalizării echipamentului oficial PRDP;</li>
                          <li>Tipărirea noilor flyere și distribuirea lor;</li>
                          <li>Organizarea logistică a protestului național;</li>
                          <li>Lansarea shop-ului PRDP;</li>
                          <li>Continuarea demersurilor juridice;</li>
                          <li>Pregătirea campaniei „România Dreaptă 2026”;</li>
                          <li>Extinderea acțiunilor caritabile și de suport educațional.</li>
                        </ul>
                        <p style="margin:0;color:#222;"><strong>Din estimarea cheltuielilor pentru luna în curs, <span style="color:#d4a12a;font-weight:700;">rămân neacoperiți 2.600 euro</span></strong>, sumă pe care sperăm să o completăm împreună, prin contribuțiile membrilor și simpatizanților.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Contributii -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">💬 CONTRIBUȚII ȘI SUSȚINERE</h2>
                        <p style="margin:0 0 8px 0;color:#222;">👉 Cotizațiile (<strong>50 lei/lună</strong>) sunt baza care ne ține în mișcare, dar nu pot acoperi totul.<br>
                        👉 Donațiile și sponsorizările vin tot de la noi, <strong>oamenii PRDP</strong> — din inimile celor care pot și vor să susțină visul unei Românii curate.</p>
                        <p style="margin:0;color:#222;">Fiecare contribuție contează.<br>
                        Trăim într-o lume în care totul costă, dar <strong>valorile nu au preț.</strong><br>
                        Fiecare om care renunță la o cheltuială personală și investește în PRDP construiește viitorul.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Actiuni politice si legislative -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">⚖️ ACȚIUNI POLITICE ȘI LEGISLATIVE</h2>
                        <p style="margin:0 0 8px 0;color:#222;">Lucrăm la un <strong>proiect de lege împotriva femicidului</strong>, un demers de suflet care va salva vieți și va aduce justiția mai aproape de femeile abuzate.</p>
                        <p style="margin:0 0 8px 0;color:#222;">De asemenea, urmează să:</p>
                        <ul style="margin:8px 0 0 20px;color:#222;">
                          <li>Sesizăm <strong>CCR</strong> pentru posibila încălcare a Constituției de către președintele <strong>Nicușor Dan</strong>;</li>
                          <li>Sesizăm <strong>Secretariatul General al Guvernului</strong> privind suspiciunile de mită ce planează asupra premierului <strong>Bolojan</strong>;</li>
                          <li>Transmitem <strong>luări de poziție oficiale</strong> asupra contextului economic actual.</li>
                        </ul>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Cuvinte pentru familia PRDP -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:16px;border-radius:6px;border:1px solid #e6eef7;">
                        <h2 style="margin:0 0 10px 0;color:#01358d;font-size:18px;">💖 CUVINTE PENTRU FAMILIA PRDP</h2>
                        <p style="margin:0 0 10px 0;font-style:italic;border-left:3px solid #d4a12a;padding:10px 12px;background:#fffaf0;border-radius:6px;">
                          „PRDP nu e doar un partid. E o mișcare de conștiință. O generație care refuză resemnarea și care alege să construiască o Românie dreaptă și prosperă, pas cu pas, om cu om.”
                        </p>
                        <p style="margin:0 0 8px 0;color:#222;"><strong>— Alin Claudiu Mureșanu, Președinte-Fondator</strong></p>
                        <p style="margin:0;color:#222;">Încurajăm propunerile de proiecte, idei noi, inițiative locale și asumarea conducerii filialelor de către membrii activi. Amintiți-vă că fiecare contribuție contează, iar fiecare membru PRDP este un <strong>stâlp al renașterii politice românești.</strong></p>
                      </td>
                    </tr>
                  </table>

                  <!-- Section: Privind spre viitor -->
                  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:14px;">
                    <tr>
                      <td style="padding:22px;border-radius:6px;background:#ffffff;text-align:center;">
                        <h2 style="margin:0 0 8px 0;color:#01358d;font-size:18px;">🇷🇴 PRIVIND SPRE VIITOR</h2>
                        <p style="margin:0;color:#222;">Începând cu <strong>2028</strong>, <strong>PRDP va deveni indicatorul de calitate al noii clase politice românești.</strong> România va triumfa prin oamenii cinstiți, prin forța adevărului și prin credința că binele poate învinge răul.</p>
                      </td>
                    </tr>
                  </table>

                </td>
              </tr>

              <!-- Footer / callout -->
              <tr>
                <td style="background:#f0f4f8;padding:16px;border-top:1px solid #e6eef7;text-align:center;">
                  <p style="margin:0 0 8px 0;font-weight:700;">🐝 Împreună suntem PRDP. Împreună ridicăm România.</p>
                  </td>
              </tr>

              <!-- Bottom / big footer -->
              <tr>
                <td align="center" style="background:#01358d;color:#ffffff;padding:20px 24px;">
                  <h3 style="margin:0 0 10px 0;font-size:18px;">Partidul România Dreaptă și Prosperă</h3>
                  <p style="margin:0 0 12px 0;font-size:13px;color:#e2e8f0;">© 2025 PRDP. Toate drepturile rezervate.<br/>Acest mesaj a fost trimis membrilor și susținătorilor partidului.</p>
                  <p style="margin:0 0 12px 0;">
                    <a href="https://www.instagram.com/partidulprdp/" style="color:#ffffff;text-decoration:none;padding:0 8px;">Instagram</a> &bull;
                    <a href="https://www.tiktok.com/@partidulprdp" style="color:#ffffff;text-decoration:none;padding:0 8px;">TikTok</a> &bull;
                    <a href="https://www.prdp.ro" style="color:#ffffff;text-decoration:none;padding:0 8px;">Website</a>
                  </p>
                  <p style="margin:0;font-size:12px;color:#e2e8f0;">Pentru a vă dezabona, trimiteți un e-mail la <a href="mailto:suport@prdp.ro?subject=Dezabonare Newsletter" style="color:#ffffff;text-decoration:underline;">suport@prdp.ro</a>.</p>
                </td>
              </tr>

            </table>
          </td>
        </tr>
      </table>
    </body>
    </html>
  `,
},
    {
  id: "newsletter-sept-oct-2025",
  name: "Newsletter #3 – Septembrie & Octombrie 2025",
  subject: "PRDP: Septembrie - Luna construcției, Octombrie - Luna consolidării și planurile pentru recunoașterea națională",
  getContent: (data) => `
    <!DOCTYPE html>
    <html lang="ro">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="X-UA-Compatible" content="ie=edge">
      <title>Newsletter PRDP</title>
      <style>
        @media screen and (max-width: 680px) {
          .container {
            width: 100% !important;
          }
          .content-padding {
            padding: 20px !important;
          }
          .header h1 {
            font-size: 24px !important;
          }
        }
      </style>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f4f7f9; font-family: Arial, sans-serif;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" class="container" style="max-width: 680px; width: 100%; border-collapse: collapse; background-color: #ffffff;">
        <tr>
          <td align="center" class="header content-padding" style="padding: 30px 40px; background-color: #ffffff; border-bottom: 4px solid #01358d;">
            <h1 style="color: #01358d; margin: 0; font-size: 28px;">Partidul România Dreaptă și Prosperă</h1>
            <p style="color: #555555; margin: 5px 0 0; font-size: 16px;">Newsletter #3 – Septembrie & Octombrie 2025</p>
          </td>
        </tr>
        <tr>
          <td class="content-padding" style="padding: 30px 40px 20px 40px;">
            <p style="font-size: 16px; color: #555555; line-height: 1.6;">Dragi colegi, dragi prieteni ai Partidului România Dreaptă și Prosperă,<br/><br/>
            Privind înapoi la luna septembrie și uitându-ne la ce urmează în octombrie, e clar: scriem împreună istorie. Ceea ce construim nu a mai făcut nimeni în România – un partid curat, transparent, viu, care se ridică doar prin forța oamenilor săi.</p>
          </td>
        </tr>
        <tr>
          <td style="padding: 0 30px 20px 30px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
              <tr>
                <td class="content-padding" style="padding: 25px 30px;">
                  <h3 style="font-size: 20px; color: #01358d; margin-top: 0; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">✅ Septembrie – o lună a construcției și a inovației</h3>
                  <ul style="line-height: 1.8; color: #555555; padding-left: 20px; margin: 0;">
                    <li>Am definitivat designul materialelor personalizate (șepci, tricouri, hanorace) – prezentare oficială: sâmbătă, ora 18:30.</li>
                    <li>Am primit-o în Biroul Național PRDP pe Gina Moldoveanu.</li>
                    <li>Am confecționat steagurile PRDP, gratuite pentru cei care conduc sau deschid organizații.</li>
                    <li>Am pus bazele filialei Timișoara.</li>
                    <li>Am achiziționat un partid satelit, pentru eventuale alegeri anticipate.</li>
                    <li>Am încheiat negocieri pentru absorția unui partid neparlamentar.</li>
                    <li>Am lansat Aplicația PRDP pentru membri – premieră absolută în România.</li>
                  </ul>
                  <p style="padding-top:18px;font-size:16px; color: #555;">Aplicația oferă: buget real-time, vot online, top membri, înscriere la evenimente și notificări personalizate. PRDP e singurul partid transparent și interactiv, nefinanțat din bani publici!</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding: 0 30px 20px 30px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
              <tr>
                <td class="content-padding" style="padding: 25px 30px;">
                  <h3 style="font-size: 20px; color: #01358d; margin-top: 0; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">🔵 Octombrie – luna consolidării și a expansiunii</h3>
                  <ul style="line-height: 1.8; color: #555555; padding-left: 20px; margin: 0;">
                    <li>Finalizăm primului lot de materiale personalizate (10–15 bucăți, cost: 450–500 €).</li>
                    <li>Achiziționăm echipamente vitale (calculator performant și imprimantă).</li>
                    <li>Strângem bugetul pentru două obiective majore: redepunerea actelor și organizarea Congresului Național (7500 €).</li>
                    <li>Pregătim campanii outdoor, flyere și promovarea congresului.</li>
                    <li>Stabilim echipe de marketing și promovare.</li>
                    <li>Lansăm campanie sponsorizări prin publicitate pe site și Spider Wall.</li>
                    <li>Organizăm întâlniri oficiale pentru promovarea mapelor PRDP.</li>
                    <li>Susținem inițiativa Ginei Moldoveanu pentru copiii cu autism.</li>
                  </ul>
                  <p style="padding-top:18px;font-size:16px; color: #555;">Fiecare euro donat contează! PRDP e construit exclusiv din contribuțiile membrilor – gestul fiecăruia pune o cărămidă la viitorul României.</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding: 0 30px 20px 30px;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
              <tr>
                <td class="content-padding" style="padding: 25px 30px;">
                  <h3 style="font-size: 20px; color: #01358d; margin-top: 0; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">🏛️ Congresul PRDP – Decembrie 2025</h3>
                  <p style="font-size: 16px; color: #555555; line-height: 1.6; margin-top: 0;">Congresul din Parlamentul României va fi momentul zero al recunoașterii naționale. Pentru a ajunge acolo, fiecare implicare contează!</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="content-padding" style="padding: 10px 40px 30px 40px;">
            <h3 style="font-size: 20px; color: #01358d; margin-top: 20px; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">💬 Mesaj din partea Președintelui Fondator</h3>
            <p style="font-size: 16px; color: #555555; line-height: 1.6; margin-top: 0;">Dragi colegi,</p>
            <p style="font-size: 16px; color: #555555; line-height: 1.6;">În fiecare zi PRDP crește. Nu prin bani publici, nu prin compromisuri, nu prin foști politicieni reciclați. Crește prin munca și loialitatea voastră.<br/>
            Luptăm doar cu forțele proprii împotriva unui sistem care ar prefera să nu existăm. Rezistăm, creștem, ne dezvoltăm.<br/></p>
            <p style="font-size: 16px; color: #555555; line-height: 1.6;">De aceea, vă rog:<br/>
              <ul style="line-height: 1.8; color: #555555; padding-left: 20px; margin: 0;">
                <li>adăugați cel puțin un membru nou pe săptămână;</li>
                <li>contribuiți la bugetul partidului – fiecare euro contează;</li>
                <li>fiți vizibili în comunități, pe stradă, în viața reală.</li>
              </ul>
            </p>
            <p style="font-size: 16px; color: #555555; line-height: 1.6;">Fiecare donație e un act de construcție. Nu donăm doar bani, donăm încredere, viitor și putere. Fiecare euro este un pas înainte către recunoaștere, Parlament, România pe care o visăm.</p>
            <p style="font-size: 16px; color: #555555; line-height: 1.6;">PRDP este mai mult decât un partid. Este o mișcare națională care va fi construită doar de fiecare dintre noi. Împreună facem ceea ce alții nu au reușit. Împreună scriem o poveste pe care România o aștepta de decenii.<br/>Cu respect și recunoștință,<br/>Alin Claudiu Mureșanu<br/>Președinte Fondator PRDP</p>
          </td>
        </tr>
        <tr>
          <td class="content-padding" style="padding: 0 40px 40px 40px; text-align: center;">
            <h3 style="font-size: 20px; color: #01358d; margin-top: 20px; margin-bottom: 20px;">🔔 Concluzie</h3>
            <ul style="line-height: 1.8; color: #555555; padding-left: 20px; margin: 0; list-style-type: disc; font-size:16px;">
              <li>✔ Septembrie a fost luna construcției.</li>
              <li>✔ Octombrie este luna consolidării.</li>
              <li>✔ Decembrie va fi luna recunoașterii naționale.</li>
            </ul>
            <p style="font-size: 16px; color: #555555; margin-top: 22px;">
              Istoria nu se scrie de la sine. Se scrie prin muncă, sacrificiu, loialitate și credință. Și exact asta facem noi în fiecare zi. <br/>Fiecare membru, fiecare gest, fiecare euro donat înseamnă un pas înainte.<br/>
              <strong style="color: #2b2b2b;">PRDP trăiește prin voi. Vă mulțumim că sunteți parte din această luptă.</strong>
            </p>
          </td>
        </tr>
        <tr>
          <td align="center" class="content-padding" style="padding: 30px 40px; background-color: #01358d; color: #ffffff;">
            <h3 style="margin: 0; font-size: 20px;">Partidul România Dreaptă și Prosperă</h3>
            <p style="margin: 15px 0; font-size: 14px; line-height: 1.6; color: #e2e8f0;">
              © 2025 PRDP. Toate drepturile rezervate.<br/>
              Acest mesaj a fost trimis membrilor și susținătorilor partidului.
            </p>
            <p style="margin-bottom: 15px;">
              <a href="https://www.instagram.com/partidulprdp/" style="color: #ffffff; text-decoration: none; padding: 0 10px;">Instagram</a> &bull;
              <a href="https://www.tiktok.com/@partidulprdp" style="color: #ffffff; text-decoration: none; padding: 0 10px;">TikTok</a> &bull;
              <a href="https://www.prdp.ro" style="color: #ffffff; text-decoration: none; padding: 0 10px;">Website</a>
            </p>
            <p style="margin: 0; font-size: 12px; line-height: 1.6; color: #e2e8f0;">
              Pentru a vă dezabona, trimiteți un e-mail la 
              <a href="mailto:suport@prdp.ro?subject=Dezabonare Newsletter" style="color: #ffffff; text-decoration: underline;">suport@prdp.ro</a>.
            </p>
          </td>
        </tr>
      </table>
    </body>
    </html>
  `,
},
    {
        id: "newsletter-august-2025",
        name: "Newsletter #2 – August 2025",
        subject: "PRDP: Realizările lunii August și planurile pentru viitor",
        getContent: (data) => `
          <!DOCTYPE html>
          <html lang="ro">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
            <title>Newsletter PRDP</title>
            <style>
              @media screen and (max-width: 680px) {
                .container {
                  width: 100% !important;
                }
                .content-padding {
                  padding: 20px !important;
                }
                .header h1 {
                  font-size: 24px !important;
                }
              }
            </style>
          </head>
          <body style="margin: 0; padding: 0; background-color: #f4f7f9; font-family: Arial, sans-serif;">
            <table align="center" border="0" cellpadding="0" cellspacing="0" class="container" style="max-width: 680px; width: 100%; border-collapse: collapse; background-color: #ffffff;">
                    <tr>
                      <td align="center" class="header content-padding" style="padding: 30px 40px; background-color: #ffffff; border-bottom: 4px solid #01358d;">
                        <h1 style="color: #01358d; margin: 0; font-size: 28px;">Partidul România Dreaptă și Prosperă</h1>
                        <p style="color: #555555; margin: 5px 0 0; font-size: 16px;">Newsletter #2 – August 2025</p>
                      </td>
                    </tr>
      
                    <tr>
                      <td class="content-padding" style="padding: 30px 40px 20px 40px;">
                        <h2 style="font-size: 22px; color: #2b2b2b; margin-top: 0;">Dragi colegi, dragi prieteni,</h2>
                        <p style="font-size: 16px; color: #555555; line-height: 1.6;">Suntem într-un moment în care munca, pasiunea și energia investite în PRDP dau roade vizibile. Punem temelia unei mișcări politice solide, transparente și conectate la vocea fiecărui român.</p>
                      </td>
                    </tr>
      
                    <tr>
                      <td style="padding: 0 30px 20px 30px;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
                          <tr>
                            <td class="content-padding" style="padding: 25px 30px;">
                              <h3 style="font-size: 20px; color: #01358d; margin-top: 0; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">🌟 Reușitele noastre recente</h3>
                              <ul style="line-height: 1.8; color: #555555; padding-left: 20px; margin: 0;">
                                <li>Demararea proiectului <strong>„Biblioteca Digitală PRDP”</strong>.</li>
                                <li>Realizarea ediției PRDP a <strong>Constituției României</strong>.</li>
                                <li><strong>Aplicația PRDP pentru membri</strong>, finalizată în proporție de 80%.</li>
                                <li>Reușită juridică majoră: obținerea unui <strong>satelit legal</strong>.</li>
                              </ul>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
      
                    <tr>
                      <td style="padding: 0 30px 20px 30px;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
                          <tr>
                            <td class="content-padding" style="padding: 25px 30px;">
                              <h3 style="font-size: 20px; color: #01358d; margin-top: 0; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">🏆 Top 5 Membri – Luna August</h3>
                              <p style="font-size: 16px; color: #555555; line-height: 1.6; margin-top: 0;">Felicitări celor mai activi membri! Implicarea voastră este motorul acestui partid.</p>
                              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                <tr><td style="padding: 12px; background-color: #f8fafc; border-left: 4px solid #FFC107; font-size: 18px; color: #2b2b2b;"><strong>1.</strong> &nbsp;David</td></tr>
                                <tr><td height="10"></td></tr>
                                <tr><td style="padding: 12px; background-color: #f8fafc; border-left: 4px solid #c0c0c0; font-size: 16px; color: #555555;"><strong>2.</strong> &nbsp;Alin Mureșanu</td></tr>
                                <tr><td height="10"></td></tr>
                                <tr><td style="padding: 12px; background-color: #f8fafc; border-left: 4px solid #cd7f32; font-size: 16px; color: #555555;"><strong>3.</strong> &nbsp;Georgiana</td></tr>
                                <tr><td height="10"></td></tr>
                                <tr><td style="padding: 12px; background-color: #f8fafc; border-left: 4px solid #e2e8f0; font-size: 16px; color: #555555;"><strong>4.</strong> &nbsp;Oana</td></tr>
                                <tr><td height="10"></td></tr>
                                <tr><td style="padding: 12px; background-color: #f8fafc; border-left: 4px solid #e2e8f0; font-size: 16px; color: #555555;"><strong>5.</strong> &nbsp;Gina Moldoveanu</td></tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    
                    <tr>
                      <td style="padding: 0 30px 20px 30px;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 8px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
                          <tr>
                            <td class="content-padding" style="padding: 25px 30px;">
                              <h3 style="font-size: 20px; color: #01358d; margin-top: 0; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">🎯 Obiective pentru Septembrie</h3>
                              <ul style="line-height: 1.8; color: #555555; padding-left: 20px; margin: 0;">
                                <li>Lansarea aplicației pentru membri.</li>
                                <li>Eliberarea legitimațiilor de membru și voluntar.</li>
                                <li>Deschiderea filialelor din <strong>Brașov</strong> și <strong>Giurgiu</strong>.</li>
                                <li>Pregătirea primei conferințe naționale PRDP.</li>
                              </ul>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
      
                    <tr>
                      <td class="content-padding" style="padding: 10px 40px 30px 40px;">
                        <h3 style="font-size: 20px; color: #01358d; margin-top: 20px; margin-bottom: 20px; border-bottom: 2px solid #e2e8f0; padding-bottom: 10px;">📌 Anunțuri importante</h3>
                        <p style="font-size: 16px; color: #555555; line-height: 1.6; margin-top: 0;"><strong>Întâlnirile săptămânale:</strong> în fiecare sâmbătă, ora <strong>11:30</strong> (ora României).</p>
                        <p style="font-size: 16px; color: #555555; line-height: 1.6;"><strong>Întâlnire la Brașov:</strong> Sâmbăta aceasta, Președintele Fondator, Alin Claudiu Mureșanu, vă invită la o cafea. Detalii la <a href="mailto:contact@prdp.ro" style="color: #01358d; text-decoration: underline; font-size: 15px;">contact@prdp.ro</a>.</p>
                      </td>
                    </tr>
                    
                    <tr>
                      <td class="content-padding" style="padding: 0 40px 40px 40px; text-align: center;">
                        <p style="font-size: 18px; font-weight: bold; color: #2b2b2b; margin-top: 20px;">
                          Împreună facem istorie.
                        </p>
                      </td>
                    </tr>
      
                    <tr>
                      <td align="center" class="content-padding" style="padding: 30px 40px; background-color: #01358d; color: #ffffff;">
                        <h3 style="margin: 0; font-size: 20px;">Partidul România Dreaptă și Prosperă</h3>
                        <p style="margin: 15px 0; font-size: 14px; line-height: 1.6; color: #e2e8f0;">
                          © 2025 PRDP. Toate drepturile rezervate.<br/>
                          Acest mesaj a fost trimis membrilor și susținătorilor partidului.
                        </p>
                        <p style="margin-bottom: 15px;">
                          <a href="https://www.instagram.com/partidulprdp/" style="color: #ffffff; text-decoration: none; padding: 0 10px;">Instagram</a> &bull;
                          <a href="https://www.tiktok.com/@partidulprdp" style="color: #ffffff; text-decoration: none; padding: 0 10px;">TikTok</a> &bull;
                          <a href="https://www.prdp.ro" style="color: #ffffff; text-decoration: none; padding: 0 10px;">Website</a>
                        </p>
                        <p style="margin: 0; font-size: 12px; line-height: 1.6; color: #e2e8f0;">
                          Pentru a vă dezabona, trimiteți un e-mail la 
                          <a href="mailto:suport@prdp.ro?subject=Dezabonare Newsletter" style="color: #ffffff; text-decoration: underline;">suport@prdp.ro</a>.
                        </p>
                      </td>
                    </tr>
                  </table>
            </body>
          </html>
        `
      },
];